<template>
  <div class="product-custom">
    <!-- <div class="main-title">
        产品工坊
        <el-button class="fixed-back-btn" @click="$tools.goback()" v-if="isOne">返回</el-button>
    </div> -->
    <headBox title="产品工坊" :showBack="isOne"></headBox>
    <div class="body">
      <div class="info-box">
        <img src="@static/images/product/edit-icon.png" />
        <span>您可自定义产品测算项，将定制测算方案存为模板，将模板链接发给特定人群投保，不同产品可自定义测算项不相同。</span>
      </div>
      <div class="look" v-if="showEmpty">
        <div class="item">
          <div class="text1">定制前</div>
          <div class="text2">招商信诺利多多3号终身寿险（分红型）默认产品方案</div>
          <img src="@static/images/product/web1.png" alt="" />
        </div>
        <div class="item">
          <div class="text1">定制后</div>
          <div class="text2">支持个性化产品方案定制</div>
          <img src="@static/images/product/web2.png" alt="" />
        </div>
        <div class="btn" @click="goProductlibrary">进入商品库开始定制</div>
      </div>
      <div class="table-page" v-if="showList">
        <div class="tools-box">
          <div v-if="isOne"></div>
          <div class="list-form" v-else>
            <label>产品名称</label>
            <el-input placeholder="请输入…" size="small" v-model="search.productName"></el-input>
            <label>模板名称</label>
            <el-input placeholder="请输入…" size="small" v-model="search.name"></el-input>
            <el-button size="small" class="org-btn search-btn" @click="handleCurrentChange(1)">查询</el-button>
          </div>
          <el-button class="org-btn add-btn" size="small" plain @click="goAddPage">+ 创建模板</el-button>
        </div>
        <el-table border :data="tableData" style="width: 100%" class="list-table" tooltip-effect="dark">
          <el-table-column property="productName" min-width="230px;" label="产品名称" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column property="name" label="模板名称" min-width="230px;" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column property="remark" label="备注" min-width="200px;" :show-overflow-tooltip="true"></el-table-column>
          <!-- <el-table-column property="lowPrice" min-width="130px;" label="模板最低保费(元)"></el-table-column> -->
          <el-table-column property="updateTime" min-width="150px;" label="更新时间">
            <template slot-scope="scope">
              <span>{{ scope.row.updateTime | timeSubstr(0, 16) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" min-width="280px" fixed="right">
            <template slot-scope="scope">
              <el-button-group class="line-btn-box">
                <el-button type="text" size="small" @click="edit(scope.row)">编辑</el-button>
                <el-button type="text" size="small" class="copy" @click="copy(scope.row.productUrl)">复制投保链接</el-button>
                <el-popover placement="bottom" width="216" trigger="click" popper-class="template-popover">
                  <canvas :id="'canvas' + scope.row.id"></canvas>
                  <div class="text" @click="downloadCode('canvas' + scope.row.id, scope.row.productName)">下载二维码</div>
                  <el-button type="text" size="small" slot="reference" @click="codesc('canvas' + scope.row.id, scope.row.productUrl)">二维码</el-button>
                </el-popover>
                <el-button type="text" size="small" @click="openLink(scope.row.productUrl)">预览</el-button>
                <el-button type="text" size="small" class="red" @click="del(scope.row)">删除</el-button>
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="page"
          :current-page.sync="pageNum"
          background
          layout="total,prev, pager, next"
          :page-size="10"
          @current-change="handleCurrentChange"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import headBox from '@/components/head.vue';
import Clipboard from 'clipboard';
var QRCode = require('qrcode');
//当前实例组件
export default {
  data: () => ({
    isInit: false,
    isOne: false,
    showEmpty: false, //无数据界面
    showList: false, //无数据界面
    pageNum: 1,
    total: 0,
    search: {
      productName: '',
      name: ''
    },
    tableData: []
  }),
  watch: {
    $route: {
      handler(val, oldval) {
        this.isInit = true;
        if (this.$route.query.productName) {
          this.search.productName = this.$route.query.productName;
          this.isOne = true;
        } else {
          this.search.productName = '';
          this.isOne = false;
        }
        this.handleCurrentChange(1);
      },
      // 深度观察监听
      deep: true,
      immediate: true
    }
  },
  components: { headBox },
  methods: {
    goAddPage() {
      if (this.$route.query.productId) {
        this.$router.push({
          path: '/product/customEdit',
          query: {
            productId: this.$route.query.productId
          }
        });
      } else {
        this.goProductlibrary();
      }
    },
    // 跳转产品库
    goProductlibrary() {
      this.$router.push({
        path: '/productlibrary',
        query: {
          custom: 1
        }
      });
    },
    openLink(url) {
      window.open(url);
    },
    // 下载二维码
    downloadCode: function (id, name) {
      var url = document.getElementById(id).toDataURL('image/png');
      this.$tools.dataToBlob(name, url);
    },
    // 显示二维码
    codesc(id, url) {
      var canvas = document.getElementById(id);
      QRCode.toCanvas(canvas, url, { width: 200, height: 200 }, function (error) {
        if (error) console.error(error);
        console.log('success!');
      });
    },
    copy: function (link) {
      var that = this;
      var clipboard = new Clipboard('.copy', {
        text: function () {
          return link;
        }
      });
      clipboard.on('success', function (e) {
        that.linkVisible = false;
        that.$message({
          message: '复制成功',
          type: 'success'
        });
        clipboard.destroy();
      });
    },
    getParams() {
      const params = {};
      if (this.$route.query.productName) {
        params.productName = this.$route.query.productName;
      }
    },
    // 翻页
    handleCurrentChange(page) {
      const params = Object.assign({}, this.search);
      params.pageNum = page;
      params.pageSize = 10;
      this.$http({
        url: '/master/measureCustom/list',
        type: 'put',
        params: params
      }).then(res => {
        res.data.forEach(item => {
          delete item.formData;
          delete item.tpl;
        });
        console.log(res.data);
        this.tableData = res.data;
        this.total = res.total;
        if (page == 1 && this.isInit == true) {
          this.isInit = false;
          if (res.data.length) {
            this.showList = true;
            this.showEmpty = false;
          } else if (this.isOne) {
            this.$router.replace({
              path: '/product/customOne',
              query: this.$route.query
            });
          } else {
            this.showList = false;
            this.showEmpty = true;
          }
        }
      });
    },
    edit(item) {
      this.$router.push({
        path: '/product/customEdit',
        query: {
          isAll: !this.isOne,
          id: item.id,
          productId: item.productId
        }
      });
    },
    del(item) {
      this.$confirm('确认删除模板？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http({
          url: '/master/measureCustom/delete',
          type: 'put',
          params: { id: item.id }
        }).then(data => {
          this.handleCurrentChange(1);
          this.$message.success('删除成功');
        });
      });
    }
  }
};
</script>
<style lang="scss">
@import './customEntry';
</style>
